import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class ModifierLienEnfantCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private idEnfant: string,
        private temoinObligatoire: boolean
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService.modifierLienEnfant(this.id, this.idEnfant, this.temoinObligatoire).pipe(
            tap(om => {
                this.events.structureModifiee$.next(this.id);
                this.events.objetMaquetteModifie$.next(om);
            })
        );
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService.modifierLienEnfant(this.id, this.idEnfant, !this.temoinObligatoire).pipe(
            tap(om => {
                this.events.structureModifiee$.next(this.id);
                this.events.objetMaquetteModifie$.next(om);
            })
        );
    }
}
